import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@companycam/slab-web';

import { translate } from 'translations/i18n';

const ButtonDiv = styled.div`
  padding: 16px;
  display: flex;
  align-items: flex-end;
  flex-direction: row-reverse;
  gap: 12px;
  background-color: var(--cc_color_background_2);
`;

const MessageText = styled.p`
  padding: 24px;
  margin: 32px 0;
`;

const Confirm = ({ message, cancelAction, confirmAction, confirmLabel }) => {
  return (
    <>
      <MessageText>{message}</MessageText>
      <ButtonDiv>
        <Button color="destroy" onClick={confirmAction}>
          {confirmLabel}
        </Button>
        <Button onClick={cancelAction} aria-label={translate('common.cancel')}>
          {translate('common.cancel')}
        </Button>
      </ButtonDiv>
    </>
  );
};

Confirm.propTypes = {
  message: PropTypes.string.isRequired,
  cancelAction: PropTypes.func.isRequired,
  confirmLabel: PropTypes.string.isRequired,
  confirmAction: PropTypes.func.isRequired,
};

export default Confirm;
